import React from "react";
import { Form, Button, InputGroup, Image } from "react-bootstrap";
import { isEmpty } from "lodash";
import { Formik, Field } from "formik";
import {
  SearchableList,
  FieldDropSide,
  FormControlSearch,
  MultiSelectDropdown,
} from "../../../components";
import {
  toOptionValuesFromMapper,
  toMultiSelectValueById,
  OPTIONS_DATA_MAPPER,
} from "../../../utils";

const initialValues = {
  investmentType: null,
  investmentStatus: null,
  advisorRep: null,
  custodian: null,
};

const all = { label: "All", value: null };

const PlanFilterComponent = ({
  fields,
  filteredValues,
  advisorsData,
  custodianData,
  onFormSubmit,
  investmentTypes,
}) => {
  return (
    <Formik
      initialValues={{
        ...initialValues,
      }}
      onSubmit={onFormSubmit}
      enableReinitialize
      validateOnChange={false}
      validateOnBlur={false}
    >
      {({
        handleChange,
        setFieldValue,
        setFieldError,
        handleSubmit,
        setValues,
        values,
        ...rest
      }) => {
        return (
          <Form
            autoComplete="off"
            className="mb-20 mt-10"
            onSubmit={handleSubmit}
            validated={!isEmpty(rest.errors)}
          >
            <div className="d-flex align-item-center pad-50-right">
              <div className="search-bar-investment-var mt-16">
                <InputGroup>
                  <InputGroup.Prepend>
                    <InputGroup.Text className="plan-search-button">
                      <Image src="/assets/icons/svg/search.svg" width="14px" />
                    </InputGroup.Text>
                  </InputGroup.Prepend>
                  <FormControlSearch
                    type="search"
                    placeholder="Search investment name, ticker, CUSIP"
                    onChange={(e) => {
                      setFieldValue(fields.search, e.target.value);
                    }}
                  />
                </InputGroup>
              </div>
              <div className="d-flex ml-3">
                <Field
                  size="sm"
                  isRequired
                  name={fields.investmentType}
                  label={"Investment Type"}
                  value={values[fields.investmentType]}
                  options={[
                    all,
                    ...investmentTypes.map((type, index) => ({
                      label: type.name,
                      value: parseInt(type.id),
                    })),
                  ]}
                  popupContent={
                    <SearchableList
                      label="Select an Investment Type"
                      isRadio
                      selectedValue={values[fields.investmentType]}
                      options={[
                        all,
                        ...investmentTypes.map((type, index) => ({
                          label: type.name,
                          value: parseInt(type.id),
                        })),
                      ]}
                      onSelect={(value) =>
                        setFieldValue(fields.investmentType, value)
                      }
                    />
                  }
                  component={FieldDropSide}
                />
              </div>
              <div className="d-flex ml-3">
                <Field
                  isRequired
                  name={fields.advisors}
                  size={"sm"}
                  label={"Advisor Rep."}
                  isMultiSelect
                  value={toMultiSelectValueById(
                    values[fields.advisors],
                    advisorsData &&
                      advisorsData.map((item, index) => ({
                        label: item.advisorCompanyName,
                        value: item.advisorPlanMapId,
                      }))
                  )}
                  popupContent={
                    <MultiSelectDropdown
                      label="Advisor Rep."
                      name={fields.advisors}
                      onSelect={(value) => {
                        setFieldValue(fields.advisors, value);
                      }}
                      value={values[fields.advisors]}
                      options={
                        advisorsData &&
                        advisorsData.map((item, index) => ({
                          label: item.advisorCompanyName,
                          value: item.advisorPlanMapId,
                        }))
                      }
                      isTypeAhead
                    />
                  }
                  component={FieldDropSide}
                />
              </div>
              <div className="d-flex ml-3">
                <Field
                  size="sm"
                  isRequired
                  name={fields.custodian}
                  label={"Clearing Partner"}
                  value={values[fields.custodian]}
                  options={[
                    all,
                    ...custodianData.map((item, index) => ({
                      label: item.custodianCompanyName,
                      value: item.custodianPlanMapId,
                    })),
                  ]}
                  popupContent={
                    <SearchableList
                      label="Select an Clearing Partner"
                      isRadio
                      selectedValue={values[fields.custodian]}
                      options={[
                        all,
                        ...custodianData.map((item, index) => ({
                          label: item.custodianCompanyName,
                          value: item.custodianPlanMapId,
                        })),
                      ]}
                      onSelect={(value) =>
                        setFieldValue(fields.custodian, value)
                      }
                    />
                  }
                  component={FieldDropSide}
                />
              </div>
              <div className="d-flex ml-3">
                <Field
                  name={fields.investmentStatus}
                  isRequired
                  size="sm"
                  label="Investment Status"
                  value={values[fields.investmentStatus]}
                  options={[
                    all,
                    ...toOptionValuesFromMapper(
                      OPTIONS_DATA_MAPPER.INVESTMENT_STATUS_MASTER
                    ),
                  ]}
                  popupContent={
                    <SearchableList
                      label="Select an investment status"
                      options={[
                        all,
                        ...toOptionValuesFromMapper(
                          OPTIONS_DATA_MAPPER.INVESTMENT_STATUS_MASTER
                        ),
                      ]}
                      onSelect={(value) =>
                        setFieldValue(fields.investmentStatus, value)
                      }
                    />
                  }
                  component={FieldDropSide}
                />
              </div>

              <Button
                className="ml-3 mt-12 sort-button"
                style={{ lineHeight: "19px" }}
                variant="secondary"
                type="submit"
              >
                Search
              </Button>
            </div>
            <div className="d-flex justify-content-end">
              <p className="investment-count font-weight-500">
                {!isEmpty(filteredValues)
                  ? filteredValues.length > 1
                    ? `${filteredValues.length} investments found`
                    : `${filteredValues.length} investment found`
                  : `0 investments found`}
              </p>
            </div>
          </Form>
        );
      }}
    </Formik>
  );
};

export default PlanFilterComponent;
